
    <section class="heading-container" [ngClass]="{'d-none':showCollege}">
        <h2><span>{{EXAMS[selectedExam].NAME}}</span> College Predictor</h2>
        <p>Helping you decide the college of your Dreams</p>
        <div class="carousel-container" > 
            <div class="college-predictor-block">
                <div class="owl-carousel college-predictor">
                    <div class="item">
                        <div class="college-img">
                            <img src="/assets/img/s3-images/picasso/college-predictor/college-predictor1.png" class="userpic" alt="College" />
                            <div class="college-name">IIT Indore</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="college-img">
                            <img src="/assets/img/s3-images/picasso/college-predictor/college-predictor2.png" class="userpic" alt="College" />
                            <div class="college-name">IIT Gandhinagar</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="college-img">
                            <img src="/assets/img/s3-images/picasso/college-predictor/college-predictor3.png" class="userpic" alt="College" />
                            <div class="college-name">IIT Mandi</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="college-img">
                            <img src="/assets/img/s3-images/picasso/college-predictor/college-predictor4.png" class="userpic" alt="College" />
                            <div class="college-name">IIT Dhanbad</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="college-img">
                            <img src="/assets/img/s3-images/picasso/college-predictor/college-predictor5.png" class="userpic" alt="College" />
                            <div class="college-name">IIT Roorkee</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="college-img">
                            <img src="/assets/img/s3-images/picasso/college-predictor/college-predictor6.png" class="userpic" alt="College" />
                            <div class="college-name">IIT Kharagpur</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <ng-container *ngIf="!showCollege; else collegeTpl">
    <section class="exam-details">
        <div class="container">
            <div class="exam-details-container">
                <h2>Enter Your <span>{{EXAMS[selectedExam].SUB_HEADING}} Exam Details</span></h2>
                <form>
                    <div class="form-group">
                      <label>{{EXAMS[selectedExam].SUB_HEADING}} Rank</label>
                      <input type="number" class="form-control" autocomplete="new-password" placeholder="Enter {{EXAMS[selectedExam].SUB_HEADING}} Rank" (input)="getUserRank($event)"/>
                    </div>
                    <div class="form-group">
                        <label>Select Preferred Branches <span>(Max 3)</span></label>
                        <div class="branch-container">
                            <ul>
                                <li [ngClass]="{'active':selectedBranchList.includes(branch.id)}" *ngFor="let branch of branchesList" (click)="selectBranch(branch.id)">
                                    <img [src]="branch.image" (click)="selectBranch(branch)" alt="Branch Icon"/>
                                    {{branch.name}}
                                </li>
                            </ul>
                        </div> 
                    </div>
                    <div class="form-group">
                        <label>Select your Category</label>
                        <div class="category-container">
                            <ul>
                                <li *ngFor="let category of categoryList" (click)="selectCategory(category.id)" [ngClass]="{'active':category.id === selectedCategory}">{{category.name}}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="form-group" *ngIf="selectedExam === DEFAULT_EXAM_MAIN">
                        <label>Select your Quota</label>
                        <div class="category-container">
                            <ul>
                                <li *ngFor="let quota of quotaList" (click)="selectQuota(quota.id)" [ngClass]="{'active':quota.id === selectedQuota}">{{quota.name}}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="submit-cta">
                        <button class="btn btn-primary" [disabled]="!checkForm" (click)="onSubmit()">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    </section>
    <section class="help-container">
        <h2>How Can <span>College Predictor Help You?</span></h2>
        <div class="container">
            <div class="helpChoice-container">
                <div class="help-content">
                    <img src="/assets/img/s3-images/picasso/college-list-icon.svg"  alt="College List Icon"/>
                    <b>Preferred College List</b>
                    <p>A list of college & courses as per the branch of your choice</p>
                </div>
                <div class="help-content">
                    <img src="/assets/img/s3-images/picasso/chances-icon.svg" alt="College List"/>
                    <b>Know Your Chances</b>
                    <p>Chances of getting into the college on the basis of your rank</p>
                </div>
                <div class="help-content">
                    <img src="/assets/img/s3-images/picasso/best-batch-icon.svg" alt="College List"/>
                    <b>Find The Best Match</b>
                    <p>Your preferred courses where your chances of getting into are high</p>
                </div>
            </div>
        </div>
    </section>
</ng-container>
<ng-template #collegeTpl>
    <app-college-predictor-listing [data]="predColleges" [examType]="EXAMS[selectedExam].NAME" [branches]="branchesList"></app-college-predictor-listing>
</ng-template>

<div class="modal fade" id="collegePredictorInfo" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
          <div class="signup-head" data-dismiss="modal">
            <span><img src="assets/images/new-home/close.svg" alt="close"  /></span>
          </div>
        <div class="VerifyOTPScreen">
            <h3>Enter Your Details</h3>
            <div class="form-group mb-0">
              <app-free-trial-form  [formType]="FORM_TYPE"></app-free-trial-form>
            </div>
          </div>
      </div>
    </div>
  </div>
<app-otp-verify-modal *ngIf="enableVerifyOTPPopup" [mobileInfo]="mobileInfo" [displayType]="FORM_TYPE"></app-otp-verify-modal>
